"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _search = _interopRequireDefault(require("./rest-api/search"));
// this file was autogenerated, do not modify

var searchConfigs = {
  'rest-api': _search.default
};
var _default = exports.default = searchConfigs;
//# sourceMappingURL=search.js.map